'use strict';

export class Link {
  constructor() {
    console.log('Link module');
  }
}
